import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

const parseError = async (response, fallback) => {
  const text = await response.text();
  try {
    const parsed = JSON.parse(text);
    return parsed?.error || parsed?.message || parsed?.title || fallback;
  } catch {
    return text?.trim() || fallback;
  }
};

const getJson = async (path, fallback) => {
  const response = await fetch(`${API_BASE_URL}/Printlet/${path}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error(await parseError(response, fallback));
  return response.json();
};

const postJson = async (path, body, fallback) => {
  const response = await fetch(`${API_BASE_URL}/Printlet/${path}`, {
    method: "POST",
    headers: authHeaders(),
    body: body == null ? undefined : JSON.stringify(body),
  });
  if (!response.ok) throw new Error(await parseError(response, fallback));
  if (response.status === 204) return {};
  return response.json();
};

export const fetchPrintletSettings = () => getJson("Settings", "فشل تحميل إعدادات Printlet");
export const fetchPrintletDashboard = (fromUtc, toUtc) => {
  const qs = new URLSearchParams();
  if (fromUtc) qs.set("fromUtc", fromUtc);
  if (toUtc) qs.set("toUtc", toUtc);
  const suffix = qs.toString() ? `?${qs}` : "";
  return getJson(`Dashboard${suffix}`, "فشل تحميل لوحة Printlet");
};
export const fetchPrintletOrders = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== "") qs.set(k, v);
  });
  return getJson(`Orders?${qs}`, "فشل تحميل طلبات Printlet");
};
export const fetchPrintletOrder = (id) => getJson(`Orders/${id}`, "فشل تحميل تفاصيل طلب Printlet");
export const previewPrintletSend = (girabatOrderId) =>
  getJson(`Orders/Preview/${girabatOrderId}`, "فشل فحص الطلب");
export const sendOrderToPrintlet = (girabatOrderId) =>
  postJson(`Orders/${girabatOrderId}/Send`, null, "فشل الإرسال إلى Printlet");
export const bulkSendOrdersToPrintlet = (orderIds) =>
  postJson("Orders/BulkSend", { orderIds }, "فشل الإرسال الجماعي إلى Printlet");
export const retryPrintletOrder = (id) => postJson(`Orders/${id}/Retry`, null, "فشل إعادة المحاولة");
export const refreshPrintletOrder = (id) => postJson(`Orders/${id}/Refresh`, null, "فشل التحديث");
export const verifyPrintletCod = (id, verified = true) =>
  postJson(`Orders/${id}/VerifyCod`, { verified }, "فشل تأكيد COD");
export const payPrintletWallet = (id) => postJson(`Orders/${id}/PayWallet`, null, "فشل الدفع من المحفظة");
export const cancelPrintletOrder = (id) => postJson(`Orders/${id}/Cancel`, null, "فشل إلغاء طلب Printlet");
export const fetchPrintletMappings = () => getJson("Mappings", "فشل تحميل الربط");
export const fetchMissingPrintletMappings = () => getJson("Mappings/Missing", "فشل تحميل الأنواع غير المربوطة");
export const createPrintletMapping = (body) => postJson("Mappings", body, "فشل حفظ الربط");
export const bulkCreatePrintletMappings = (typeIds, allUnmapped = false) =>
  postJson("Mappings/Bulk", allUnmapped ? { allUnmapped: true } : { typeIds }, "فشل الربط الجماعي");
export const updatePrintletMapping = async (id, body) => {
  const response = await fetch(`${API_BASE_URL}/Printlet/Mappings/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(await parseError(response, "فشل تحديث الربط"));
  return response.json();
};
export const deletePrintletMapping = async (id) => {
  const response = await fetch(`${API_BASE_URL}/Printlet/Mappings/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error(await parseError(response, "فشل حذف الربط"));
};
export const fetchPrintletCatalog = () => getJson("Catalog", "فشل تحميل كتالوج Printlet");
export const fetchPrintletCatalogSyncStatus = () => getJson("Catalog/Sync", "فشل حالة مزامنة الكتالوج");
export const syncPrintletCatalog = () => postJson("Catalog/Sync", null, "فشل مزامنة الكتالوج");
export const fetchPrintletEvents = (page = 1) => getJson(`Events?page=${page}`, "فشل تحميل الأحداث");
export const fetchPrintletWallet = () => getJson("Wallet", "فشل تحميل المحفظة");
export const fetchPrintletCityMappings = () => getJson("CityMappings", "فشل تحميل ربط المدن");
export const savePrintletCityMapping = (body) => postJson("CityMappings", body, "فشل حفظ ربط المدينة");
export const fetchPrintletCities = () => getJson("Cities", "فشل تحميل المدن");
export const fetchPrintletGirabatTypes = () => getJson("GirabatTypes", "فشل تحميل الأنواع");
export const runPrintletSync = () => postJson("Sync", null, "فشل مزامنة Printlet");
